type TOrganization = {
  id: string;
  slug: string;
  name: string;
};

export const getJoinedOrganizationSlug = (
  previousOrganizationIds: string[],
  organizations: TOrganization[],
  organizationName: string,
): string | undefined => {
  const joinedOrganization = organizations.find((org) => !previousOrganizationIds.includes(org.id));

  if (joinedOrganization) {
    return joinedOrganization.slug;
  }

  return organizations.find((org) => org.name === organizationName)?.slug;
};
